/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */
define('global/LocalStorageHelper',[
    './Logger'
], function (Logger) {
    'use strict';


    /*  removeStorage: removes a key from localStorage and its sibling expiracy key
    params: key <string>   : localStorage key to remove
    returns: <boolean> : telling if operation succeeded
    */
    function removeStorage(name) {
        try {
            localStorage.removeItem(name);
            localStorage.removeItem(name + '_expiresIn');
        } catch (e) {
            Logger.debug('removeStorage: Error removing key [' + key + '] from localStorage: ' + JSON.stringify(e));
            return false;
        }
        return true;
    }

    /*  getStorage: retrieves a key from localStorage previously set with setStorage().
        params:
            key <string> : localStorage key
        returns:
            <string> : value of localStorage key
            null : in case of expired key or failure
     */
    function getStorage(key) {
        var now = Date.now();  
        // set expiration for storage
        var expiresIn = localStorage.getItem(key + '_expiresIn');
        if (expiresIn === undefined || expiresIn === null) { expiresIn = 0; }

        if (expiresIn < now) {// Expired
            removeStorage(key);
            return null;
        } else {
            try {
                var value = localStorage.getItem(key);
                return value;
            } catch (e) {
                Logger.debug('getStorage: Error reading key [' + key + '] from localStorage: ' + JSON.stringify(e));
                return null;
            }
        }
    }

    /*  setStorage: writes a key into localStorage setting a expire time
        params:
            key <string>     : localStorage key
            value <string>   : localStorage value
            expires <number> : number of seconds from now to expire the key
        returns:
            <boolean> : telling if operation succeeded
     */
    function setStorage(key, value, expires) {

        if (expires === undefined || expires === null) {
            expires = (24 * 60 * 60);  // default: seconds for 1 day
        } else {
            expires = Math.abs(expires); //make sure it's positive
        }

        var now = Date.now();  //millisecs since epoch time, lets deal only with integer
        var schedule = now + expires * 1000;
        try {
            localStorage.setItem(key, value);
            localStorage.setItem(key + '_expiresIn', schedule);
        } catch (e) {
            Logger.debug('setStorage: Error setting key [' + key + '] in localStorage: ' + JSON.stringify(e));
            return false;
        }
        return true;
    }

    var LocalStorageHelper = {
        removeStorage: removeStorage,
        getStorage: getStorage,
        setStorage: setStorage
    };

    Logger.debug('LocalStorageHelper.js Loaded:', LocalStorageHelper);

    return LocalStorageHelper;
});
